import {Component} from 'vue-property-decorator';
import {BlockViewModal} from './block.viewmodal';
import {namespace} from 'vuex-class' ;
import {
  SEARCH_AUTOCOMPLETE,
  SEARCH_MODULE_NAMESPACE,
  SEARCH_REQUEST_BYKEYS,
  SEARCH_REQUEST_BYKEYS_FORCE
} from '../../../../store/search';
import {SearchEntities, CrudStatus} from '../../../../common/enums';
import {BLOCK_MODULE_NAMESPACE} from '../../../../store/block';
import {IBlockListingViewModel} from "../../../../models/block";


const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)


@Component({})
class BlockModalVertical extends BlockViewModal {
  dtRules: {
    namesRules?: any
    addressRules?: any
    zipcodeRules?: any
    cityRules?: any
    countryRules?: any
    num_lotsRules?: any
    managersRules?: any
  }
  dtSaveCurrentManager: any[]
  dtSaveCurrentCaretaker: any[]
  dtSaveCurrentSalesperson: any[]

  constructor() {
    super()
    this.dtRules = {}
    this.dtSaveCurrentManager = []
    this.dtSaveCurrentCaretaker = []
    this.dtSaveCurrentSalesperson = []
  }

  @SearchStore.Getter caretakers: any[];
  @SearchStore.Getter managers: any[];
  @SearchStore.Getter salespersons: any[]
  @BlockStore.Getter blockCrudActionStatus: CrudStatus;
  @BlockStore.Getter currentBlock: IBlockListingViewModel;

  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetMasterData: (payload?: { keys: SearchEntities[] }) => Promise<any>;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;


  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/validation-messages').default
    }
  }


  get textConfigs() {
    return require("@/assets/json-resources/text-field-configs.json")
  }

  get isUpdateAction(): boolean {
    return this.blockCrudActionStatus === CrudStatus.Update
  }


  get coConcierges() {
    return (this.currentBlock.caretakers || []).concat((this.dtSaveCurrentCaretaker || []).concat(this.caretakers || []))
  }

  get coCommercials() {
    return (this.currentBlock.salespersons || []).concat((this.dtSaveCurrentSalesperson || []).concat(this.salespersons || []))
  }

  get coManagers() {
    return (this.currentBlock.managers || []).concat((this.dtSaveCurrentManager || []).concat(this.managers || []))
  }

  created() {
    this.storeGetMasterData({
      keys: [
        SearchEntities.Manager,
        SearchEntities.CareTaker,
        SearchEntities.Salesperson
      ]
    }).catch(error => console.log('get master data error', error))
  }

  mounted() {
    this.dtRules = {
      namesRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.blockNameForm)})
      ],
      addressRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.blockAddressForm)})
      ],
      zipcodeRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.blockPostalCodeForm)})
      ],
      cityRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.blockCityForm)})
      ],
      countryRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.blockCountryForm)})
      ],
      num_lotsRules: [v => (!!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.blockNbrLotsForm)}))
        && (!isNaN(v) || this.$t(this.lblSetting.numberRequired))],
      managersRules: [(v) => (!!v && v.length > 0) || this.$t(this.lblSetting.managersRequired)]
    }
    this.dtSaveCurrentManager = this.currentBlock.managers
  }

  handleGetManagers(key: string) {
    return this.storeGetEntitySearch({
      entity: [SearchEntities.Manager],
      query: key,
      limit: 50
    })
  }

  handleGetCaretaker(key: string) {
    return this.storeGetEntitySearch({
      entity: [SearchEntities.CareTaker],
      query: key,
      limit: 50
    })
  }

  handleGetSalesperson(key: string) {
    return this.storeGetEntitySearch({
      entity: [SearchEntities.Salesperson],
      query: key,
      limit: 50
    })
  }

  handleChangeManager(val) {
    this.dtSaveCurrentManager = this.keepSelectedValue(this.managers_list, this.dtSaveCurrentManager, this.managers)
  }

  handleChangeCaretaker(val) {
    this.dtSaveCurrentCaretaker = this.keepSelectedValue(this.concierge, this.dtSaveCurrentCaretaker, this.caretakers)
  }

  handleChangeSalesperson(val) {
    this.dtSaveCurrentSalesperson = this.keepSelectedValue(this.commercial, this.dtSaveCurrentSalesperson, this.salespersons)
  }

  keepSelectedValue(selected, saved, list) {
    let newSaved = []
    selected.map(x => {
      if (saved.findIndex(y => y.id === x) === -1) {
        let contractorToAdd = list.find(y => y.id === x)
        if (contractorToAdd) {
          newSaved.push(contractorToAdd)
        }
      }
    })
    return newSaved
  }

}

export default BlockModalVertical



// WEBPACK FOOTER //
// ./src/containers/block/components/block-modal-vertical/index.ts